<template>
  <div>
    <div id="periods" class="field has-addons is-pulled-left">
      <p class="control">
        <button class="button is-small is-hidden-mobile">{{ $t('app.periods') }}</button>
        <button class="button is-small is-hidden-tablet">P</button>
      </p>
      <p v-for="item in periods" v-bind:key="item.id" class="control">
        <button
          v-on:click="setPeriod(item)"
          class="button is-small"
          v-bind:class="{ 'is-link': (item == period) }"
        >{{ item }}</button>
      </p>
    </div>
    <div id="chart"></div>
  </div>
</template>

<script>
import axios from "axios";
import { createChart } from "lightweight-charts";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"])
  },
  data: function() {
    return {
      periods: [1, 5, 15, 30, 60, "G", "H", "A", "Y"],
      period: "G",
      chart: null,
      candlestickSeries: null,
      series: [],
      chartSettings: {
        width: document.querySelector(".container").clientWidth,
        height: 500,
        timeScale: {
          timeVisible: true,
          secondsVisible: false
        }
      }
    };
  },
  mounted: function() {
    this.chart = createChart(
      document.querySelector("#chart"),
      this.chartSettings
    );
    this.candlestickSeries = this.chart.addCandlestickSeries();
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      axios
        .get(
          process.env.VUE_APP_PROXY +
          "cmd=CHART2?symbol=" +
            this.symbol +
            "?periyot=" +
            this.period +
            "?bar=220" +
            "?lang=" +
            this.$i18n.locale,
          { responseType: "json" }
        )
        .then(response => this.initJSON(response));
    },
    initJSON: function(response) {
      this.series = [];
      let data = response.data;
      data.forEach(item => {
        this.series.push({
          time: Math.round(
            new Date(
              item.Date.replace(/[.]/gi, "-").replace(" ", "T")
            ).getTime() / 1000
          ),
          open: parseFloat(item.Open),
          high: parseFloat(item.High),
          low: parseFloat(item.Low),
          close: parseFloat(item.Close)
        });
      });
      this.candlestickSeries.setData(this.series);
      this.chart.timeScale().fitContent();
    },
    setPeriod: function(item) {
      this.period = item;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
#periods {
  position: relative;
  z-index: 39;
}
</style>